/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Card, Text } from '@chakra-ui/react';
import { NgGenericTask } from '@karya/core';
import { FixedEnumInputParam } from '@karya/core/src/Index';
import { ReactNode } from 'react';
import { ColorMap } from '@/themes/Attributes';
import { platformMessageDisplayList } from '../FormParameters/Basic';

type BubbleProps = {
  children: ReactNode;
  type: NgGenericTask[string]['ctype'];
  messageDisplay?: FixedEnumInputParam;
  transparent?: boolean;
};
export function Bubble(props: BubbleProps) {
  const { children, type, messageDisplay, transparent } = props;
  let location, bgColor, messageDisplayText;
  switch (type) {
    case 'USER':
      location = 'end';
      break;
    case 'PLATFORM':
      location = 'start';
      break;
    case 'BACKGROUND_LOCAL':
    case 'BACKGROUND_SERVER':
    case 'BATCH_BACKGROUND_SERVER':
      location = 'center';
      break;
    default:
      return null;
  }
  if (
    type === 'PLATFORM' &&
    (messageDisplay?.value === 'EXAMPLE' ||
      messageDisplay?.value === 'TUTORIAL' ||
      messageDisplay?.value === 'REFERENCE')
  ) {
    bgColor = '#F9FAE3';
    messageDisplayText = platformMessageDisplayList[messageDisplay?.value];
  } else {
    bgColor = ColorMap.white;
    messageDisplayText = '';
  }

  return (
    <Card
      alignSelf={location}
      p="10px"
      bg={transparent ? 'transparent' : bgColor}
      boxShadow={transparent ? 'none' : undefined}
      borderTopRightRadius={'8px'}
      borderBottomLeftRadius={'8px'}
      borderBottomRightRadius={type === 'PLATFORM' ? '8px' : '0px'}
      borderTopLeftRadius={type === 'PLATFORM' ? '0px' : '8px'}
      maxWidth="80%"
    >
      <Text fontSize="sm" color={'#008857'}>
        {messageDisplayText}
      </Text>
      {children}
    </Card>
  );
}
